/**
 * @generated SignedSource<<510065c8aff08da63551fab687a93173>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TeamSettingsQuery$variables = {
  teamId: string;
};
export type TeamSettingsQuery$data = {
  readonly team: {
    readonly __typename: "Team";
    readonly id: string;
    readonly objectivesFilterAssignee: ReadonlyArray<string> | null;
    readonly objectivesFilterCycle: ReadonlyArray<string> | null;
    readonly objectivesFilterStatus: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type TeamSettingsQuery = {
  response: TeamSettingsQuery$data;
  variables: TeamSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterAssignee",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterStatus",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterCycle",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSettingsQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "Team",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamSettingsQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "Team",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c257bed0ca63edd8aab3f085eda7bad6",
    "id": null,
    "metadata": {},
    "name": "TeamSettingsQuery",
    "operationKind": "query",
    "text": "query TeamSettingsQuery(\n  $teamId: ID!\n) {\n  team: node(id: $teamId) {\n    __typename\n    ... on Team {\n      __typename\n      id\n      objectivesFilterAssignee\n      objectivesFilterStatus\n      objectivesFilterCycle\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "82cb7fd0f67251163bcbb685af4128e5";

export default node;
